import { outter_post,post } from 'common/js/axios-helper';
import { OrganCashApi } from "./constant/UrlMapper";



const host = '8880';
const list = (data) => {
    return outter_post(OrganCashApi.List, data, host);
};

const add = (data) => {
    return outter_post(OrganCashApi.Add, data, host);
};

const update = (data) => {
    return outter_post(OrganCashApi.Update, data, host);
};
const clickSwitch = (data) => {
    return outter_post(OrganCashApi.ClickSwitch, data, host);
};

const detail = (data) => {
    return outter_post(OrganCashApi.Detail, data, host);
};

const dpStatus = (data) => {
    return outter_post(OrganCashApi.DpStatus, data, host);
};

const delInfo = (data) => {
    return outter_post(OrganCashApi.Delete, data, host);
};

const isExist = (data) => {
    return outter_post(OrganCashApi.IsExist, data, host);
};

const cardTatAwardList = (data) => {
    return outter_post(OrganCashApi.CardTatAwardList, data, host);
};

const cardTatAwardAdd = (data) => {
    return outter_post(OrganCashApi.CardTatAwardAdd, data, host);
};

const cardTatAwardEdit = (data) => {
    return outter_post(OrganCashApi.CardTatAwardEdit, data, host);
};


const cardTatAwardDetail = (data) => {
    return outter_post(OrganCashApi.CardTatAwardDetail, data, host);
};


const cardTatAwardCheck = (data) => {
    return outter_post(OrganCashApi.CardTatAwardCheck, data, host);
};

const cardTatAwardDel = (data) => {
    return outter_post(OrganCashApi.CardTatAwardDel, data, host);
};

const tatCardTestList = (data) => {
    return outter_post(OrganCashApi.TatCardTestList, data, host);
};

const tatCardTestAdd = (data) => {
    return outter_post(OrganCashApi.TatCardTestAdd, data, host);
};

const tatCardTestEdit = (data) => {
    return outter_post(OrganCashApi.TatCardTestEdit, data, host);
};


const tatCardTestDetail = (data) => {
    return outter_post(OrganCashApi.TatCardTestDetail, data, host);
};


const tatCardTestCheck = (data) => {
    return outter_post(OrganCashApi.TatCardTestCheck, data, host);
};

const tatCardTestDel = (data) => {
    return outter_post(OrganCashApi.TatCardTestDel, data, host);
};

const addAllDel = (data) => {
    return post(OrganCashApi.addAllDel,data,host)
}
export default {

    list,
    add,
    update,
    detail,
    clickSwitch,
    dpStatus,
    delInfo,
    isExist,
    cardTatAwardList,
    cardTatAwardAdd,
    cardTatAwardEdit,
    cardTatAwardDetail,
    cardTatAwardCheck,
    cardTatAwardDel,
    tatCardTestList,
    tatCardTestAdd,
    tatCardTestEdit,
    tatCardTestDetail,
    tatCardTestCheck,
    tatCardTestDel,
    addAllDel
}



// WEBPACK FOOTER //
// ./src/service/OrganCashService.js